import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  addAppointmentService,
  getAppointmentServicesFull,
  getAppointmentServicesTypes,
  removeAppointmentService,
  replaceAppointmentService,
} from 'src/store/appointment.store'
import { AppButton } from 'components/FormElements/AppButton/AppButton'
import { ServiceList } from 'components/Appointment/ServiceList/ServiceList'
import styles from './ServicesPicker.module.scss'

type ServicesPickerProps = {
  clientIndex: number,
  onSubmit: () => void,
}

/** Picks services for one client of the booking */
export const ServicesPicker: React.FC<ServicesPickerProps> = (props) => {
  const { clientIndex, onSubmit } = props
  const dispatch = useDispatch()
  const selectedServices = useSelector(getAppointmentServicesFull)
  const selectedServicesTypes = useSelector(getAppointmentServicesTypes)

  const addService = (id: number, amount: number) => {
    dispatch(addAppointmentService({ clientIndex, service: { id, amount } }))
  }

  const handleServiceSelect = (serviceId: number, amount: number, isSelected: boolean) => {
    if (isSelected) {
      dispatch(removeAppointmentService({ clientIndex, serviceId }))
    } else {
      addService(serviceId, amount)
    }
  }

  const handleServiceAmountChange = (serviceId: number, amount: number, isSelected: boolean) => {
    if (isSelected) {
      addService(serviceId, amount)
    }
  }

  const handleServiceReplace = (serviceId: number, newServiceId: number, amount: number) => {
    dispatch(replaceAppointmentService({ clientIndex, serviceId, service: { id: newServiceId, amount } }))
  }

  return (
    <div className={styles.container}>
      <div className={styles.categories}>
        <ServiceList
          selectedServicesTypes={selectedServicesTypes[clientIndex]}
          selectedServices={selectedServices[clientIndex]}
          onServiceSelect={handleServiceSelect}
          onServiceAmountChange={handleServiceAmountChange}
          onServiceReplace={handleServiceReplace}
        />
      </div>
      <div className={styles.actions}>
        <AppButton onClick={() => onSubmit()}>ОК</AppButton>
      </div>
    </div>
  )
}
